"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {findIn, closest, findAll, findAllIn, on} from '@elements/dom-utils';
import * as Chartist from "chartist";
import fetch from '@elements/fetch';

const defaultOptions = {};

const defaultSelectors = {
    base: '.js-tour-height-chart',
    canvas: '.js-tour-height-chart__canvas'
};

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createChart(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createChart(baseElement, options, selectors) {
    let canvasElements = findAllIn(selectors.canvas, baseElement);
    canvasElements.forEach(function(canvas) {
        renderChart(canvas, baseElement);
    });
}

function renderChart(canvas, baseElement) {
    let url = canvas.getAttribute('data-tour-height-chart-url');
    let pendingRequest = fetch(url);

    pendingRequest.then((data) => {
        return data.clone().json();
    }).then((data) => {
        drawGraph(canvas, baseElement, data);
    }).catch((error) => {
        if (error.name !== 'AbortError') {
            console.error(error);
        }
    });
}

function drawGraph(canvas, baseElement, data) {
    let options = {
        fullWidth: true,
        axisY: {
            type: Chartist.AutoScaleAxis,
            labelInterpolationFnc: function(value) {
                return value + ' hm'
            },
            offset: matchMedia('(max-width: 767px)').matches ? 40 : 60
        },
        axisX:{
            labelInterpolationFnc: function(value, index) {
                let totalLabels = matchMedia('(max-width: 767px)').matches ? 3 : 8;
                return  index % Math.round(data.labels.length / totalLabels) === 0 ? (Math.round(value * 10) / 10) + ' km' : null;
            },
            showGrid: false,
            offset: matchMedia('(max-width: 767px)').matches ? 10 : 40

        },
        lineSmooth: Chartist.Interpolation.cardinal(),
        showPoint: false,
        showArea: true,
        chartPadding: {
            right: matchMedia('(max-width: 767px)').matches ? 10 : 40
        },
        low: 0,
    };

    let chart = new Chartist.Line(canvas, data, options );

    chart.on('draw', function(data) {
        if(data.type === 'line' || data.type === 'area') {
            data.element.animate({
                d: {
                    begin: 2000 * data.index,
                    dur: 2000,
                    from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                    to: data.path.clone().stringify(),
                    easing: Chartist.Svg.Easing.easeOutQuint
                }
            });
        }
    });

    return data;
}